/**
 * @generated SignedSource<<b0968b77b26404d29d197231a42ba38c>>
 * @relayHash ca173adec2ec050b9d287791181aafd6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e0bf785b553a61f7462013419a0fb4761d3b694028019e57401fb22058dd6ed2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ThemePreferenceMutation$variables = {
  theme: string;
};
export type ThemePreferenceMutation$data = {
  readonly updateUserPreferences: {
    readonly theme: string;
  } | null | undefined;
};
export type ThemePreferenceMutation = {
  response: ThemePreferenceMutation$data;
  variables: ThemePreferenceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "theme"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "theme",
            "variableName": "theme"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "theme"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ThemePreferenceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThemePreferenceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ca173adec2ec050b9d287791181aafd6",
    "id": "e0bf785b553a61f7462013419a0fb4761d3b694028019e57401fb22058dd6ed2",
    "metadata": {},
    "name": "ThemePreferenceMutation",
    "operationKind": "mutation",
    "text": "mutation ThemePreferenceMutation($theme:String!){updateUserPreferences(userPreferences:{theme:$theme}){theme}}"
  }
};
})();

(node as any).hash = "3cd1ca8244910a8e5bce4751e216f026";

export default node;
